import { useState, useEffect } from "react";

// Единственная точка, где живёт мобильный брейкпоинт панели. То же значение продублировано
// в CSS (@media (max-width: 900px)) — менять их надо парой.
export const NARROW_QUERY = '(max-width: 900px)';

const mediaQueryList = () => (typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia(NARROW_QUERY)
    : null);

// Разовая проверка (для начального состояния и обработчиков).
export const isNarrowScreen = () => Boolean(mediaQueryList()?.matches);

// Подписка на смену режима: поворот телефона и изменение размера окна меняют вёрстку
// без перезагрузки, поэтому компоненты, которые ветвятся по ширине, должны перерисоваться.
export function useIsNarrow() {
    const [isNarrow, setIsNarrow] = useState(isNarrowScreen);

    useEffect(() => {
        const mql = mediaQueryList();
        if (!mql) return undefined;
        const handler = (event) => setIsNarrow(event.matches);
        mql.addEventListener('change', handler);
        return () => mql.removeEventListener('change', handler);
    }, []);

    return isNarrow;
}
